<template>
    <UtilitiesWebView url="/city-tours?tour-type=Bus" />
</template>
